module.exports = __webpack_public_path__ + "static/media/Videos 4.b204ef18.svg";